import { render, staticRenderFns } from "./topics-tasks.vue?vue&type=template&id=133d1430&scoped=true&"
import script from "./topics-tasks.vue?vue&type=script&lang=js&"
export * from "./topics-tasks.vue?vue&type=script&lang=js&"
import style0 from "./topics-tasks.vue?vue&type=style&index=0&id=133d1430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d1430",
  null
  
)

export default component.exports